import React from 'react';
import * as ReactRouterDOM from 'react-router-dom';
import { useAppContext } from '../../context/AppContext.js';
import NumericBox from '../../components/NumericBox.js';
import { getWords } from '../../utils/get-words.js';

const BudgetCapitalTopPart3Part1 = ReactRouterDOM.withRouter(function ({ budgetCapital, body, updateBody, validated }) {
  const { i18n, setError } = useAppContext();
  const words = getWords(i18n.code);

  return (
    <div>
      <div>
        <div className="d-flex justify-content-between">
          <div className="pt-2">
            <NumericBox
              label={words.jan}
              value={body.janAmount}
              onChange={(value) => updateBody('janAmount', value)}
              validated={validated}
              required
            />
          </div>
          <div className="pt-2">
            <NumericBox
              label={words.feb}
              value={body.febAmount}
              onChange={(value) => updateBody('febAmount', value)}
              validated={validated}
              required
            />
          </div>
          <div className="pt-2">
            <NumericBox
              label={words.mar}
              value={body.marAmount}
              onChange={(value) => updateBody('marAmount', value)}
              validated={validated}
              required
            />
          </div>
          <div className="pt-2">
            <NumericBox
              label={words.apr}
              value={body.aprAmount}
              onChange={(value) => updateBody('aprAmount', value)}
              validated={validated}
              required
            />
          </div>
          <div className="pt-2">
            <NumericBox
              label={words.may}
              value={body.mayAmount}
              onChange={(value) => updateBody('mayAmount', value)}
              validated={validated}
              required
            />
          </div>
          <div className="pt-2">
            <NumericBox
              label={words.jun}
              value={body.junAmount}
              onChange={(value) => updateBody('junAmount', value)}
              validated={validated}
              required
            />
          </div>
          <div className="pt-2">
            <NumericBox
              label={words.jul}
              value={body.julAmount}
              onChange={(value) => updateBody('julAmount', value)}
              validated={validated}
              required
            />
          </div>
          <div className="pt-2">
            <NumericBox
              label={words.aug}
              value={body.augAmount}
              onChange={(value) => updateBody('augAmount', value)}
              validated={validated}
              required
            />
          </div>
          <div className="pt-2">
            <NumericBox
              label={words.sep}
              value={body.sepAmount}
              onChange={(value) => updateBody('sepAmount', value)}
              validated={validated}
              required
            />
          </div>
          <div className="pt-2">
            <NumericBox
              label={words.oct}
              value={body.octAmount}
              onChange={(value) => updateBody('octAmount', value)}
              validated={validated}
              required
            />
          </div>
          <div className="pt-2">
            <NumericBox
              label={words.nov}
              value={body.novAmount}
              onChange={(value) => updateBody('novAmount', value)}
              validated={validated}
              required
            />
          </div>
          <div className="pt-2">
            <NumericBox
              label={words.dec}
              value={body.decAmount}
              onChange={(value) => updateBody('decAmount', value)}
              validated={validated}
              required
            />
          </div>
        </div>
      </div>
    </div>
  );
})

export default BudgetCapitalTopPart3Part1;
